import { useState } from "react";

import { strCode } from "../../consts";
import { log, notificationService, releaseNotesService, t } from "../../services";
import { useUploadReleaseNotesIcons } from "./useUploadReleaseNotesIcons";

export const useCreateReleaseNotes = () => {
  const [loading, setLoading] = useState(false);

  const { mutationCallback: uploadReleaseNotesIcons } = useUploadReleaseNotesIcons();

  const mutationCallback = async (releaseNotes, mediaData) => {
    try {
      setLoading(true);

      const { mediaUrls, thumbnailUrls } = await releaseNotesService.createReleaseNotes(
        releaseNotes
      );
      const { media, thumbnails } = mediaData ?? {};

      const mediaPromises = [];

      if (mediaUrls && media) {
        mediaPromises.push(uploadReleaseNotesIcons(mediaUrls, media));
      }

      if (thumbnailUrls && thumbnails) {
        mediaPromises.push(uploadReleaseNotesIcons(thumbnailUrls, thumbnails));
      }

      await Promise.all(mediaPromises);
    } catch (error) {
      log.error("useCreateReleaseNotes: Failed to create release notes", error);
      notificationService.showError({
        title: t(strCode.CREATE_FWU_VERSION_ERROR),
        message: error?.response?.data?.message ? error.response.data.message : error?.toString()
      });
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return { mutationCallback, loading };
};
